import { Component } from '@angular/core';

@Component({
  selector: 'app-highlight-section',
  imports: [],
  templateUrl: './highlight-section.component.html',
  styleUrl: './highlight-section.component.css',
})
export class HighlightSectionComponent {

}
